<div class="w-screen h-screen overflow-hidden flex flex-nowrap">
  <div class="w-72 h-full" *ngIf="!(standalone$ | async)">
    <app-navbar>
      <app-navbar-item title="{{ 'menu.projects' | translate }}" icon="/assets/images/icon-projects.svg" link="/panel/projects"></app-navbar-item>
      <app-navbar-item appAdminAccess title="{{ 'menu.tags' | translate }}" icon="/assets/images/icon-tag.svg" link="/panel/tags"></app-navbar-item>
      <app-navbar-item appAdminAccess title="{{ 'menu.unmatched-point-clouds' | translate }}" icon="/assets/images/icon-projects.svg" link="/panel/point-clouds/unmatched"></app-navbar-item>
    </app-navbar>
  </div>
  <div class="flex-grow h-full overflow-y-auto p-8">
    <div>
      <ngx-loading-bar color="#ff7200" [includeSpinner]="false" [fixed]="true"></ngx-loading-bar>
    </div>
    <router-outlet></router-outlet>
  </div>
</div>
